<div class="navbar-area">
    <div class="mobile-nav">
        <a routerLink="/" class="logo"><img src="assets/img/logo/logo.png" alt="Logo" width="150"></a>
    </div>

    <div class="nav-two main-nav">
        <div class="container-fluid">
            <nav class="container-max navbar navbar-expand-md navbar-light ">
                <!-- SEARCH (LEFT) -->
                <div class="nav-search">
                    <input type="text" placeholder="Looking for?" />
                    <button type="button">
                        <i class="flaticon-loupe"></i>
                    </button>
                </div>
                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav m-auto gap-1">
                        <li class="nav-item m-auto"><a routerLink="/" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Home</a></li>
                                <li class="nav-item m-auto"><a routerLink="/product" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Products</a></li>
                        <li class="nav-item m-auto"><a routerLink="/brand" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Brands</a></li>
                        <li class="nav-item m-auto"><a routerLink="/recipe" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Recipes</a></li>
                        <li class="nav-item m-auto"><a routerLink="/private-label" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Private Label</a></li>
                        <li class="nav-item m-auto"><a routerLink="/careers" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Careers</a></li>
                        <li class="nav-item m-auto dropdown">
                            <a href="javascript:void(0)" class="nav-link">Contact <i class='bx bx-plus'></i></a>
                            <ul class="dropdown-menu">
                                <li class="nav-item"><a routerLink="/contact-uae" class="nav-link" routerLinkActive="active">Contact UAE</a></li>
                                <li class="nav-item"><a routerLink="/contact-oman" class="nav-link" routerLinkActive="active">Contact Oman</a></li>
                            </ul>
                        </li>
                        <li class="nav-item m-auto"><a routerLink="/" class="default-btn" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}" style="    color: white !important;
                                text-transform: capitalize;padding: 10px 30px; border-radius: 8px;">Corporate</a></li>
                    </ul>

                    
                </div>
                <div class="d-in-line align-items-center d-flex d-none d-lg-flex">
                    <a class="navbar-brand logo-right" routerLink="/">
                        <img src="assets/img/logo/logo.png" alt="Logo">
                    </a>
                </div>
            </nav>
        </div>
    </div>
</div>

<div class="search-overlay">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-layer"></div>
            <div class="search-layer"></div>
            <div class="search-layer"></div>
            <div class="search-close">
                <span class="search-close-line"></span>
                <span class="search-close-line"></span>
            </div>
            <div class="search-form">
                <form>
                    <input type="text" class="input-search" placeholder="Search here...">
                    <button type="submit"><i class="flaticon-loupe"></i></button>
                </form>
            </div>
        </div>
    </div>
</div>